import React from 'react';
import { AppFormProvider } from '@cp/utils/form';
import { Box } from '@cp/ds/src/components/box';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { Button } from '@cp/ds/src/components/button';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Counter } from './counter';
import { Tariffs } from './tariffs';
import { TariffsEditProps } from './model';

export * from './model';

export const TariffsEdit: React.FC<TariffsEditProps> = ({ form, onSubmit, afterFields, sx, isSeparatedByChildrenCount }) => {
  return (
    <AppFormProvider form={form}>
      <Box
        component="form"
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}
        sx={mergeSx({ display: 'inline-flex', flexDirection: 'column' }, sx)}
      >
        {isSeparatedByChildrenCount && <Counter form={form} />}
        <Tariffs form={form} isSeparatedByChildrenCount={isSeparatedByChildrenCount} />

        {afterFields}

        <Button
          color="pink"
          sx={{
            width: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' },
            mt: { xs: 2.5, [MOBILE_BREAKPOINT_THRESHOLD]: 5 },
          }}
          type="submit"
          variant="primary"
        >
          Cохранить
        </Button>
      </Box>
    </AppFormProvider>
  );
};
